import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const [active, setActive] = useState("");
  const navigate = useNavigate();

  const navItems = [
    "Home",
    "Book Service",
    "How It Works",
    "For Helpers",
    "Admin",
    "Login"
  ];

  const handleClick = (item) => {
    setActive(item);

    if (item === "Home") navigate("/");

    if (item === "Login") navigate("/login");

    if (item === "Admin") navigate("/admin-dashboard");

    if (item === "Book Service") navigate("/chat-booking");

    // ✅ ADDED THIS
    if (item === "For Helpers") navigate("/for-helpers");

    // Optional (if future page banaya to)
    if (item === "How It Works") navigate("/how-it-works");
  };

  return (
    <div className="flex justify-between items-center px-10 py-5 shadow-sm bg-white sticky top-0 z-50">
      
      {/* LOGO */}
      <h1
        onClick={() => navigate("/")}
        className="text-2xl font-bold flex items-center gap-2 cursor-pointer group"
      >
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-full w-9 h-9 flex items-center justify-center text-lg shadow-md group-hover:rotate-12 transition duration-300">
          🤖
        </div>
        <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent font-extrabold">
          AutoHelper AI
        </span>
      </h1>

      {/* NAV LINKS */}
      <div className="hidden md:flex gap-4 text-gray-700 font-medium">
        {navItems.map((item, index) => (
          <span
            key={index}
            onClick={() => handleClick(item)}
            className={`nav-shimmer px-5 py-2 rounded-full cursor-pointer transition-all duration-300
              ${
                active === item
                  ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-md scale-105"
                  : "hover:bg-blue-100"
              }`}
          >
            {item}
          </span>
        ))}
      </div>

      {/* BUTTON */}
      <button
        onClick={() => navigate("/chat-booking")}
        className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full font-semibold hover:scale-105 hover:shadow-lg transition duration-300"
      >
        Book Now
      </button>
    </div>
  );
}
